var map = {
	"./AdultSignatureNA.svg": "2388",
	"./B13a.svg": "c8ee",
	"./Battery.svg": "0b07",
	"./CPCPickup.svg": "5f10",
	"./CarrierEnv.svg": "960f",
	"./CarrierPak.svg": "0f7a",
	"./CurrencyPriceChange.svg": "bb45",
	"./DangerousGoods.svg": "38d7",
	"./DeliveryTimeInfo.svg": "cb96",
	"./DimensionsMissing.svg": "7262",
	"./FreightMultiPackagesWarning.svg": "ee72",
	"./FreightRequirements.svg": "134e",
	"./GLSNoPickupFee.svg": "5d71",
	"./InsuranceLimitations.svg": "6869",
	"./IsCallRequested.svg": "1b19",
	"./IsFragile.svg": "61cf",
	"./IsPickupComments.svg": "b57b",
	"./IsSignatureRequested.svg": "b33a",
	"./MerchantRedirectCPC.svg": "51e4",
	"./MerchantRedirectUPS.svg": "20e5",
	"./MinimumPackaging.svg": "efcb",
	"./NextDayPickup.svg": "7ffc",
	"./NoInsuranceWhenCustomsValueDeclared.svg": "24b1",
	"./POBox.svg": "e558",
	"./Perfume.svg": "4878",
	"./PersonalEffects.svg": "bd67",
	"./PickupNotMonitored.svg": "135d",
	"./ResidentialPickup.svg": "0e5f0",
	"./RiskOfLargePackage.svg": "376c",
	"./RiskOfOverLimit.svg": "695e",
	"./ScheduleCanparPickup.svg": "5e56",
	"./SchedulePickup.svg": "42ee",
	"./expressFreightShipment.svg": "c0ba",
	"./notification-oops.svg": "ab5d",
	"./theresACheaperOption.svg": "ebf7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2a4";